class ButtonUp {
    constructor($buttonUp, $firstScreen) {
        this.initialValue = 0;
        this.softZone = 0;
        this.duration = 400;
        this.$buttonUp = $buttonUp;
        this.$firstScreen = $firstScreen;
    }

    init() {
        this._getParams();
        this._bindEvents();
        this._control();
    }

    updateParams() {
        this.heightFirstScreen = this.$firstScreen.outerHeight();
        this.checkPoint = this.heightFirstScreen + this.positionFirstScreen + this.softZone;
    }

    _getParams() {
        this.heightFirstScreen = this.$firstScreen.outerHeight();
        this.positionFirstScreen = this.$firstScreen.offset().top;
        this.checkPoint = this.heightFirstScreen + this.positionFirstScreen + this.softZone;
    }

    _bindEvents() {
        window.addEventListener('scroll', this._toggleVisibleButtonUp.bind(this));

        this.$buttonUp.on('click', this._scrollToTop.bind(this));
    }

    _control() {
        this._toggleVisibleButtonUp();
    }

    _toggleVisibleButtonUp () {
        const scrollTop = window.scrollY;
        const isVisibleFirstScreen = scrollTop > this.checkPoint;
        this.$buttonUp.toggleClass('is-visible', isVisibleFirstScreen);
    }

    _scrollToTop() {
        $('html, body').animate({scrollTop: this.initialValue}, this.duration);
    }
}

export default ButtonUp;
